export const getUnixDate = (unixTimestamp: number): Date => {
  const date = new Date(unixTimestamp * 1000);

  return date;
};

export default getUnixDate;
